import { FC } from "react"
import { RtkHookForm } from "@/core/components"
import { Name } from "@/modules/telegram/components/mailing/name"
import { GuestBot } from "../../interfaces"
import {
  useCreateTemplateMutation,
  useUpdateTemplateMutation,
} from "../../store"
import {
  PayloadEditor,
  PayloadFormData,
  fromPayload,
  toPayload,
} from "../payload"

interface IProps {
  template?: GuestBot.Template
  onDone?: () => void
}

type FormData = { name: string } & PayloadFormData

const createDefaults: FormData = {
  name: "",
  type: "text",
  text: "",
  parseMode: null,
  media: "",
  title: "",
  mime: "application/pdf",
}

export const TemplateForm: FC<IProps> = ({ template, onDone }) => {
  // RtkHookForm привязывает один mutation-хук — выбираем его до рендера.
  const mutationHook = template
    ? useUpdateTemplateMutation
    : useCreateTemplateMutation

  const defaultValues: FormData = template
    ? { name: template.name, ...fromPayload(template.payload) }
    : createDefaults

  return (
    <RtkHookForm<FormData, GuestBot.TemplateRes>
      mutationHook={mutationHook as never}
      formContextParams={{ defaultValues }}
      // Валидация — на уровне полей (PayloadEditor); здесь только маппинг уже
      // валидной формы в тело запроса (бросок в submit-хендлере проглотится RHF).
      getSubmitHandlerParams={(data) => {
        const body = { name: data.name, payload: toPayload(data) }
        return template ? { pathParams: { id: template.id }, body } : { body }
      }}
      afterSubmit={() => onDone?.()}
      successMessage={template ? "Шаблон обновлён" : "Шаблон создан"}
      actions={[
        {
          text: "Сохранить",
          type: "submit",
          variant: "contained",
          fullWidth: true,
        },
      ]}
    >
      <Name required />
      <PayloadEditor />
    </RtkHookForm>
  )
}
